import React from 'react'
import { connect } from 'react-redux';
import {
  loanApplicationConditional,
  getLoanApplicationId,
  getErrorMessage,
  getIncomeOptions,
  getAdditionalIncomes,
  getMainIncome,
  getLoanApplicationUser,
  getCurrentLoanApplicant
} from '../../../reducers'

import {
  buildIncome,
  updateIncomeStart,
} from '../../../actions'

import ActionButtons from '../../commons/ActionButtons'
import IncomeSourceCard from './IncomeSource/IncomeSourceCard'
import AdditionalIncomes from './AdditionalIncomes'

const bonusIncomes = ['overtime', 'bonus', 'commission', 'allowance']

class Income extends React.Component {
  state = {
    errors: new Map(),
    employer: '',
    incomes: [],
    continueButtonEnabled: true,
  }

  onNewIncome(data) {
    this.props.buildIncome(data)
  }

  componentDidMount() {
    const { mainIncome, incomes } = this.props
    window.scrollTo({top: 0})

    this.setState({
      mainIncome,
      incomes
    })
  }

  convertCamelCaseToUnderscore = (object) => {
    let convertedObject = {...object}

    const mappedPropertiesForConvertion = {
      amountPreviousYear: 'amount_previous_year',
      frequencyPreviousYear: 'frequency_previous_year',
      paygIncomeType: 'payg_income_type',
      periodMonths: 'period_months',
      periodYears: 'period_years',
      locationFullAddress: 'location_full_address',
      locationAddress: 'location_address',
      locationSuburb: 'location_suburb',
      locationPostcode: 'location_postcode',
      locationState: 'location_state',
      additionalPaygIncomes: 'additional_payg_incomes',
      incomeType: 'income_type',
    }

    const propertiesForConvertion = Object.keys(mappedPropertiesForConvertion)
    const propertiesToDelete = ['active', 'error', 'incomeEmployerType', 'incomeSource']

    for (let property in convertedObject) {
      if (convertedObject.hasOwnProperty(property)) {
        // Delete camelCase properties and add underscore ones
        if (propertiesForConvertion.includes(property)) {
          convertedObject[mappedPropertiesForConvertion[property]] = convertedObject[property]
          delete convertedObject[property]
        }

        // Delete unnecessary properties
        if (propertiesToDelete.includes(property)) {
          delete convertedObject[property]
        }
      }
    }

    return convertedObject
  }

  // Go through all incomes and prepare their properties in the correct formatting
  incomesUnderscored = (allIncomes) => {
    return allIncomes.map((income) => {
      let incomeConverted = this.convertCamelCaseToUnderscore(income)

      let paygIncomes = incomeConverted.additional_payg_incomes

      if (paygIncomes && !Array.isArray(paygIncomes)) {
        let additionalIncomesArray = []
        let randomKey = new Date().valueOf()

        bonusIncomes.map((bonusIncome) => {
          // Only convert bonus incomes if they are active, otherwise we shouldn't push them to the server
          const paygIncome = paygIncomes[bonusIncome]
          if (paygIncome) {
            if (paygIncome['active'] === true) {
              paygIncome.key = paygIncome.id || randomKey++
              additionalIncomesArray.push(this.convertCamelCaseToUnderscore(paygIncome))
            } else if (paygIncome['active'] === false && paygIncome['id']) {
              additionalIncomesArray.push({ _destroy: true, id: paygIncome.id })
            } else {
              delete paygIncomes[bonusIncome]
            }
          }
        })

        delete incomeConverted.additional_payg_incomes
        incomeConverted.additional_payg_incomes_attributes = additionalIncomesArray
      }

      return incomeConverted
    })
  }

  setAmountsToZero = (income) => {
    income['amount'] = income.amount || 0;
    income['amountPreviousYear'] = income.amountPreviousYear || 0;
    const additionalIncomes = income.additionalPaygIncomes

    if (additionalIncomes && Object.keys(additionalIncomes)) {
      Object.keys(income.additionalPaygIncomes).forEach(key => {
        income.additionalPaygIncomes[key].amount = income.additionalPaygIncomes[key].amount || 0;
        income.additionalPaygIncomes[key].amountPreviousYear = income.additionalPaygIncomes[key].amountPreviousYear || 0;
      })
    }
  }

  callUpdateIncomeStart = () => {
    const {
      mainIncome,
      incomes,
      incomeSource,
      incomeEmployerType,
      currentApplicant
    } = this.props

    const allIncomes = [mainIncome, ...incomes]
    allIncomes.forEach(income => {
      this.setAmountsToZero(income)
    })

    const underscoredIncomes = this.incomesUnderscored(allIncomes)
    this.props.updateIncomeStart({
      loan_application_user: {
        income_source: incomeSource,
        income_employer_type: incomeSource !== 'selfEmployed' ? incomeEmployerType : null,
        incomes_attributes: this.incomesUnderscored(allIncomes),
      },
      currentApplicant
    })
  }

  onContinueClick = () => {
    this.callUpdateIncomeStart();
  }

  continueEnabled() {
    const errors = {}

    return Object.keys(errors).length === 0
  }

  onGoBackClick = () => {
    if (this.props.flowState === 'secondary_income') {
      return this.props.onGoBackClick
    }
  }

  render() {
    const {
      errors,
      continueButtonEnabled,
    } = this.state

    const {
      incomes,
      mainIncome,
      incomeOptions,
      loanApplication,
      currentApplicant,
      name
    } = this.props

    return (
      <div>
        <h3 className="mb-3">{name}'s income, before tax</h3>
        <IncomeSourceCard
          errors={ errors.get(mainIncome) }
          currentApplicant={currentApplicant}
          onChange={ mainIncome => {} }
        />
        <AdditionalIncomes
          incomes={ incomes }
          errors={ errors }
          availableIncomes={ incomeOptions }
          onNewIncome={ (payload) => this.onNewIncome(payload) }
          currentApplicant={currentApplicant}
          collapsed={ false }
        />
        <ActionButtons
          continueEnabled={ continueButtonEnabled }
          onContinueClick={ this.onContinueClick }
          onGoBackClick={ this.onGoBackClick() }
        />
    </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loanApplicationConditional: loanApplicationConditional(state),
    errorMessage: getErrorMessage(state),
    loanApplicationId: getLoanApplicationId(state),
    incomeOptions: getIncomeOptions(state),
    mainIncome: getMainIncome(state),
    incomes: getAdditionalIncomes(state),
    incomeEmployerType: getCurrentLoanApplicant(state, ownProps.currentApplicant).incomeEmployerType,
    incomeSource: getCurrentLoanApplicant(state, ownProps.currentApplicant).incomeSource,
    flowState: getLoanApplicationUser(state).flowState,
  }
}

export default connect(mapStateToProps, {
  updateIncomeStart,
  buildIncome,
})(Income)
